// extracted by mini-css-extract-plugin
export default {"tech-item":"TechItem_tech-item__dfz47","tech-item__img":"TechItem_tech-item__img__ObTyx","tech-item__text":"TechItem_tech-item__text__CW6Um"};